import { skipToken } from '@reduxjs/toolkit/query';
import { useSelector } from 'react-redux';
import type { ArgCatalogo, CanalCardapio, ConsumoTotem } from '../api';
import type { RootState } from '../store';

/**
 * Como o catálogo é pedido em cada canal.
 *
 * No totem de PEDIDOS o cardápio depende do consumo escolhido, então o
 * argumento carrega os dois — e como o argumento é a chave de cache do RTK, o
 * cardápio de "comer aqui" e o de "para levar" ficam em entradas separadas.
 *
 * Enquanto o cliente não escolheu, devolve `skipToken`: buscar sem consumo
 * traria a união dos dois cardápios, que ainda por cima seria usada para
 * reconciliar o carrinho e para as fotos — três entradas de cache diferentes
 * para a mesma tela. Melhor não buscar nada até haver resposta.
 */
export function argCatalogo(
  canal: CanalCardapio | undefined,
  consumo: ConsumoTotem | null,
): ArgCatalogo | typeof skipToken {
  if (!canal) return skipToken;
  if (canal !== 'CARDAPIO_TOTEM') return canal;

  return consumo ? { canal, consumo } : skipToken;
}

/** O mesmo, lendo o consumo do estado do totem de pedidos. */
export function useArgCatalogo(canal: CanalCardapio | undefined): ArgCatalogo | typeof skipToken {
  const consumo = useSelector((s: RootState) => s.totemPedidos.consumo);

  return argCatalogo(canal, consumo);
}
